export function sortByNullablePosition(
  aPosition: number | null | undefined,
  bPosition: number | null | undefined,
) {
  const newA =
    aPosition !== undefined && aPosition !== null ? aPosition + 1 : -1;
  const newB =
    bPosition !== undefined && bPosition !== null ? bPosition + 1 : 1;
  return newA - newB;
}

// Tooltips must have a unique id across the app
let tooltipLastId = 0;
export function getTooltipUniqueId(tooltipName: string) {
  tooltipLastId++;
  return `tooltip-${tooltipName}-${tooltipLastId}`;
}

export function convertFileToBase64(file: Blob) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
}

// Until we upgrade to Typescript 5.5, we need to use this function to filter out null and undefined values
export function filterEmptyDocuments<TValue>(
  value: TValue | null | undefined,
): value is TValue {
  return value !== null && value !== undefined;
}
